import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Radio, Select } from 'udesk-ui';

const Template = (props) => {
    const {
        title,
        radioValue,
        disabled,
        onRadioChange,
        getUserListUrl,
        selectValue,
        onSelectChange,
        filterOption: _filterOption,
    } = props;

    const [options, setOptions] = useState([]);

    const handleSearch = useCallback(
        (value?: string) => {
            Udesk.ajax.get(`${getUserListUrl}${value ? `&keyword=${value}` : ''}`).then(
                (resp) => {
                    const { data } = resp;
                    setOptions(
                        (data || []).map((item) => ({ label: item.realname, value: item.id }))
                    );
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales['current'].business.info.saveError
                    );
                }
            );
        },
        [getUserListUrl]
    );

    useEffect(() => {
        handleSearch();
    }, [handleSearch]);

    const filterOption = useMemo(() => {
        return _filterOption ?? (() => true);
    }, [_filterOption]);

    return (
        <>
            <div className="automatic-content-item-body-item-title automatic-content-item-body-item-title-screening-condition">
                {title}
            </div>
            <div className="automatic-content-item-body-item-content">
                <div style={{ height: 30, lineHeight: '30px' }}>
                    <Radio.Group value={radioValue} disabled={disabled} onChange={onRadioChange}>
                        {Udesk.enums.notMatchAnyRuleTypes.filter(filterOption).map((item) => {
                            return (
                                <Radio key={item.id} value={item.id}>
                                    {item.name}
                                </Radio>
                            );
                        })}
                    </Radio.Group>
                </div>
                {radioValue === Udesk.enums.notMatchAnyRuleTypes.assign.id && (
                    <Select
                        mode="multiple"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        value={selectValue || []}
                        onSearch={handleSearch}
                        onChange={onSelectChange}
                        notFoundContent={null}
                        options={options}
                        style={{ width: '100%' }}
                        maxTagCount="responsive"
                    />
                )}
            </div>
        </>
    );
};

export default Template;
